import Axios from '../services/index'
import * as React from 'react'
import { UserIdContext } from '../App'
import { UserDetailTrainingCard } from './UserDetailTrainingCard'

interface IUser {
    username: string,
    email: string,
    paid_training: Array<Int32Array>
}

//This component show personnal information of User account.
export const UserDetail: React.FunctionComponent = (props) => {

    const currentToken = localStorage.getItem('access_token')
    const {currentUserId, setCurrentUserId} = React.useContext(UserIdContext)
    const [user, setUser] = React.useState<IUser>()
    const [displayChangeMail, setDisplayChangeMail] = React.useState(false)

    React.useEffect(() => {
        Axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/users/${currentUserId}/`, {
            headers: {
                "Authorization": `Bearer ${currentToken}`
            }
        })
        .then(function(response:any) {
            setUser({
                username: response.data.username,
                email: response.data.email,
                paid_training: response.data.paid_training
            })
        })
        .catch(function(error:any) {
            alert("Une erreur est survenue ! Veuillez réessayer.")
        }) 
    },[])

    const displayUDTC = user?.paid_training.map((Id) => {
        return(<UserDetailTrainingCard id={Id} />)
    })

    const modifyMail = () => {
        setDisplayChangeMail(!displayChangeMail)
    }

    const handleSubmitMail = (event: any) => {
        event.preventDefault()
        if(event.target.oldPassword.value && event.target.newPassword.value && event.target.newPassword2.value) {
            if (event.target.oldPassword.value !== event.target.newPassword.value) {
                if (event.target.newPassword.value === event.target.newPassword2.value) {
                    Axios.post('https://LaurenceBrun.eu.pythonanywhere.com/auth/password/change/',
                    {
                        "old_password": event.target.oldPassword.value,
                        "new_password1": event.target.newPassword.value,
                        "new_password2": event.target.newPassword2.value
                    },
                    {
                        headers: {
                            "Authorization": `Bearer ${currentToken}`
                        }
                    })
                    .then(function(response:any) {
                        alert('Votre mot de passe a bien été modifié !')
                        modifyMail()

                    })
                    .catch(function(error: any){
                        alert(`Une erreur est survenue ! \n ${error}`)
                    })
                }
                else {
                    alert("Vous devez saisir votre nouveau mot de passe de manière identique dans les deux champs !")
                }
            }
            else {
                alert("Votre ancien et votre nouveau mot de passe sont identiques !")
            }
        }
        else{
            alert('Vous devez remplir tous les champs !')
        }
    }

    const displayMail = () => {
        if (displayChangeMail) {
            return(
                <>
                    <h3></h3>
                    <form className="Connect" onSubmit={handleSubmitMail}>
                        <h3>Modifier votre mot de passe</h3>
                        <label>
                            <input type="password" name="oldPassword" placeholder="Ancien mot de passe" />
                        </label><br />
                        <label>
                            <input type="password" name="newPassword" placeholder="Nouveau mot de passe" />
                        </label><br />
                        <label>
                            <input type="password" name="newPassword2" placeholder="Resaisir nouveau mot de passe" />
                        </label><br />
                        <input type="submit" value="enregistrer" className="ConnectButton Connexion" />
                    </form>
                </>
            )
        }
    }

    return(
        <div>
            <h2>Profil</h2>
            <h3>{user?.username}</h3>
            <div>votre email : {user?.email}</div>
            <h4></h4>
            <div className="ConnectButton SmallButtonFont" onClick={modifyMail}>Modifier Mot de Passe</div>
            {displayMail()}
            <h3>Liste des formations achetées : </h3>
            <ul>
                {displayUDTC}
            </ul>
        </div>
    )
}